import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Box, Heading, Text, Button, Image, Card } from 'rebass';
import { DemoProvider } from '..';
export const title = 'Demo';
export const _frontmatter = {};
const layoutProps = {
  title,
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "demo"
    }}>{`Demo`}</h1>
    <DemoProvider mdxType="DemoProvider">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "live=true",
          "live": "true"
        }}>{`<Box
  sx={{
    p: 4,
    color: 'text',
    bg: 'background',
    fontFamily: 'body',
    fontWeight: 'body',
    lineHeight: 'body',
  }}>
  <Heading variant='display'>Hello</Heading>
  <Text mb={4}>This is a demo using presets from Theme UI</Text>
  <Button mr={3}>
    Beep
  </Button>
  <Button variant='secondary'>
    Boop
  </Button>
</Box>
`}</code></pre>
    </DemoProvider>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      